import React from "react";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { sanitizeHtml } from "../../../utils/sanitizeHtml";

export const tableConstants = (permissions, showModel, wordOfTheDayDelete, page) => {
  let count = 1;
  let formatedData = [
    {
      title: 'SNo',
      render: () => {
        return <span>{(50 * page) + count++}</span>;
      },
    },
    {
      title: 'title',
      render: rowData => {
        return <span>{rowData.title}</span>;
      },
    },
    {
      title: 'Quote',
      render: rowData => {
        return <span>{rowData.quote}</span>;
      },
    },
    {
      title: 'Date',
      render: rowData => {
        return <span>{rowData.word_date}</span>;
      },
    },
    {
      title: 'Description',
      render: rowData => {
        return <span>
          {/* eslint-disable-next-line react/no-danger -- sanitized via DOMPurify in sanitizeHtml() above */}
          <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(rowData.description) }} />
        </span>;
      },
    },
    {
      title: 'Action',
      render: rowData => {
        return <span>
          {permissions.includes('word_of_the_day.update') &&
            <FontAwesomeIcon
              icon={faEdit}
              style={{
                color: "var(--color-primary-text)",
                marginRight: "10px",
                cursor: "pointer"
              }}
              onClick={() => showModel(rowData)}
            />
          }
          &nbsp;
          {permissions.includes("word_of_the_day.delete") &&
            <span
              className="cursor-pointer"
              onClick={() => {
                if (window.confirm(`Are you sure you wish to delete this item?`))
                  wordOfTheDayDelete(rowData.id)
              }}>
              <i className="fa fa-trash text-danger"></i>
            </span>
          }
        </span>;
      },
    },
  ];
  return formatedData;
};
